__turbopack_context__.v({
  "backBtn": "BackButton-module-scss-module__7KhhUa__backBtn",
  "subheader": "BackButton-module-scss-module__7KhhUa__subheader",
});
